import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/bff/client';

import mapPointShape from '../../../../pages/search/shapes/mapPoint';

import MagnifyingGlass from './icons/MagnifyingGlass';

import PlacesAPI from './places-api'; // TODO: requires window

class PlacesAutocomplete extends Component {
  static propTypes = {
    inputId: PropTypes.string.isRequired,
    boundCoords: PropTypes.shape(mapPointShape).isRequired,
    onPlaceSelected: PropTypes.func.isRequired,
    onPlaceUnselected: PropTypes.func.isRequired,
    countryCode: PropTypes.string,
    placeholder: PropTypes.string,
    focus: PropTypes.bool,
    areaSlug: PropTypes.string,
    pointOfInterest: PropTypes.object
  };

  state = {
    inputValue: ''
  };

  _prependAreaSlug = (poiStr) => {
    let result = '';
    if (this.props.areaSlug) {
      result += `${trans(`landingpage.label.${this.props.areaSlug}`)}  ›  `;
    }
    result += poiStr;
    return result;
  };

  _setPointOfInterest = (pointOfInterest) => {
    if (pointOfInterest) {
      this.setState({
        inputValue: this._prependAreaSlug(pointOfInterest.name)
      });
    } else {
      this.setState({
        inputValue: ''
      });
    }
  };

  _setFocus = () => {
    const input = document.getElementById(this.props.inputId);
    input.focus();
  };

  _getCity = () => {
    let content;
    if (this.props.areaSlug) {
      content = (
        <span className="pac-city">
          {trans(`landingpage.label.${this.props.areaSlug}`)}
          <IconGeneric size="extra-small" name="angle-right" />
        </span>
      );
    }
    return content;
  };

  _getClearButton = () => {
    let content;
    if (this.props.pointOfInterest) {
      content = (
        <span
          onClick={this.props.onPlaceUnselected}
          className="pac-clear"
          role="button"
          tabIndex={0}
        >
          {this._getPacClearIcon()}
        </span>
      );
    }
    return content;
  };

  _getPacClearIcon = () => {
    return (
      <span>
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <title>Group 5</title>
          <defs>
            <path id="a" d="M3.464 0h.693v7.62h-.693z" />
            <mask id="c" x="0" y="0" width=".693" height="7.621" fill="#fff">
              <use xlinkHref="#a" />
            </mask>
            <path id="b" d="M0 3.464h7.62v.693H0z" />
            <mask id="d" x="0" y="0" width="7.621" height=".693" fill="#fff">
              <use xlinkHref="#b" />
            </mask>
          </defs>
          <g fill="#D8D8D8" fillRule="evenodd">
            <ellipse
              className="path"
              fillOpacity=".652"
              cx="7.5"
              cy="7.5"
              rx="7.5"
              ry="7.5"
            />
            <g
              className="path"
              transform="rotate(45 1.414 10.243)"
              stroke="#979797"
              strokeWidth="1"
            >
              <use mask="url(#c)" xlinkHref="#a" />
              <use mask="url(#d)" xlinkHref="#b" />
            </g>
          </g>
        </svg>
      </span>
    );
  };

  _onInputValueChange = (event) => {
    const regexp = new RegExp(`^${this._prependAreaSlug('')}`);
    if (regexp.test(event.target.value)) {
      this.setState({
        inputValue: event.target.value
      });
    } else {
      this.setState({
        inputValue: this._prependAreaSlug('')
      });
    }
  };

  _onFocus = () => {
    if (this.state.inputValue === '') {
      this.setState({
        inputValue: this._prependAreaSlug('')
      });
    }
  };

  _onBlur = () => {
    if (this.state.inputValue === this._prependAreaSlug('')) {
      this.setState({
        inputValue: ''
      });
    }
  };

  componentDidMount() {
    this.places = new PlacesAPI(this.props.inputId, {
      radius: '50000',
      location: {
        lat: this.props.boundCoords.lat,
        lng: this.props.boundCoords.lng
      },
      componentRestrictions: {
        country: this.props.countryCode
      }
    });

    this.places.onPlaceSelected(this.props.onPlaceSelected);

    if (this.props.focus) {
      this._setFocus();
    }

    this._setPointOfInterest(this.props.pointOfInterest);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.pointOfInterest !== nextProps.pointOfInterest) {
      this._setPointOfInterest(nextProps.pointOfInterest);
    }

    if (this.props.focus !== nextProps.focus && nextProps.focus) {
      this._setFocus();
    }
  }

  render() {
    return (
      <div className="pac-wrapper">
        <span className="pac-input-icon">
          <MagnifyingGlass />
        </span>
        <input
          value={this.state.inputValue}
          onChange={this._onInputValueChange}
          onFocus={this._onFocus}
          onBlur={this._onBlur}
          className="pac-input"
          placeholder={this._prependAreaSlug(`${this.props.placeholder}…`)}
          id={this.props.inputId}
        />
        {this._getClearButton()}
      </div>
    );
  }
}

export default PlacesAutocomplete;
